interface User {
    firstName?: string
    lastName?: string
    username?: string
    email?: string
}

/**
 * Gets a display name for a user, handling missing names gracefully.
 * Falls back to username, then email, then 'Unknown User'.
 */
export const getUserDisplayName = (user: User | null | undefined): string => {
    if (!user) return 'Unknown User'

    const hasFirstName = user.firstName && user.firstName.trim()
    const hasLastName = user.lastName && user.lastName.trim()

    if (hasFirstName && hasLastName) {
        return `${user.firstName} ${user.lastName}`
    }

    return user.username || user.email || 'Unknown User'
}

/**
 * Maps a user role to its Bootstrap badge variant. Shared source of truth for the
 * role badges on the user listing and the user-edit header card. Unmapped roles fall
 * back to 'secondary'; the 'light' variant needs `text="dark"` for contrast.
 */
export const roleBadgeVariant: Record<string, string> = {
    SUPERUSER: 'danger',
    MANAGER: 'success',
    CADDIEMASTER: 'warning',
    PLAYER: 'light',
}
